module.exports = __webpack_public_path__ + "img/jingying.65c1dc57.png";